import { useSuspenseQuery } from '@fhs/client';
import { loyaltyHomepageConfigQuery, sanityClient } from '@fhs/cms-groq-queries';

export function useLoyaltyHomepageConfigQuery() {
  return useSuspenseQuery({
    queryKey: ['loyalty-homepage-config'],
    queryFn: async () => {
      const config = await sanityClient.fetch(loyaltyHomepageConfigQuery);
      return config;
    },
  });
}
